import gql from 'graphql-tag';

const externalHistoryQuery = gql`
  query ExternalHistory($productCode: ID!, $from: String, $to: String) {
    externalHistory(productCode: $productCode, from: $from, to: $to) {
      id
      configId
      categoryCode
      changeType
      changeReason
      changedBy
      changedAt
      changeSummary {
        action
        publishedBy
        reason
        timestamp
        oldConfig {
          id
          categoryCode
          configType
          effectiveFrom
          createdBy
          createdAt
          updatedAt
        }
        newConfig {
          id
          categoryCode
          configType
          effectiveFrom
          createdBy
          createdAt
          updatedAt
        }
        ruleChanges {
          type
          ruleKey
          changedFields
          before {
            id
            ruleKey
            category
            factName
            priority
            parameters
            description
            actionOnFail
            actionOnNull
            createdAt
            updatedAt
          }
          after {
            id
            ruleKey
            category
            factName
            priority
            parameters
            description
            actionOnFail
            actionOnNull
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export default externalHistoryQuery;
